import React from "react";

import ExpensesTabs from "./ExpensesTabs";
import RevenuesTabs from "./RevenuesTabs";

import lbl from "../../../../data/Labels.json";

const SideTabs = (props) => {
  return (
    <div className="report-side-tabs">
      <button
        className="daily-report-balance-btn"
        onClick={() => props.handleCurrentTab()}
      >
        {lbl.OverallBalance}
      </button>
      <RevenuesTabs {...props} />
      <ExpensesTabs {...props} />
    </div>
  );
};

export default SideTabs;
